import { render, staticRenderFns } from "./SettingsPlaceholder.vue?vue&type=template&id=21882b51&"
import script from "./SettingsPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./SettingsPlaceholder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports